import { render } from "./DashboardActiveIcon.vue?vue&type=template&id=941b9a4e"
import script from "./DashboardActiveIcon.vue?vue&type=script&lang=js"
export * from "./DashboardActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__